import React, { useState,useEffect } from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EditSTOPage from "./StoMaintain"   
import SuccessMsg from '../../Common/SuccessMsg';
import CommonAPI from '../../Common/CommonAPI';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader"; 

function ActiveStoDetails (props)  { 
    
    var StandingOrderId = JSON.parse(sessionStorage.getItem("ActiveStandHis")).id;
     const [MainCustomerName,setMainCustomerName] = useState();
     const [Benename,setBenename] = useState();
     const [BeneBankAccountNum,setBeneBankAccountNum] = useState();
     const [BankAccountNum,setBankAccountNum] = useState();
     const [Frequency,setFrequency] = useState();
     const [Amount,setAmount] = useState();
     const [BeneBank,setBeneBank] = useState();
     const [BeneBranch,setBeneBranch] = useState();
     const [StartDate,setStartDate] = useState();
     const [EndDate,setEndDate] = useState();
     const [YourReference,setYourReference] = useState();
     const [BeneReference,setBeneReference] = useState();
     const [Status,setStatus] = useState();
     const [ReferenceNumber,setReferenceNumber] = useState();
     const [Summary,setSummary] = useState([]);
     const [StartLoadingFinish,setStartLoadingFinish] = useState();
     const [SuccessLoading,setSuccessLoading] = useState(true);
     const [CancelPayment,setCancelPayment] = useState(false);
     const [ErrorMSG,setErrorMSG] = useState();
    const [SuccessMSG,setSuccessMSG] = useState(false);
    const [EnteredPassword,setEnteredPassword] = useState("");
    const [EditSTO,setEditSTO] = useState(false);
    
     useEffect( () => {
        GetSTODetailsAPI();        
      },[]);

     const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }

      const CheckFirstPassword = () =>{ 
        CommonAPI.CheckPassword({password:EnteredPassword},(results) =>{ 
         if(results.password==="true"){
             setErrorMSG();
             StopSTOAPI();
         }else{
             setErrorMSG("Enter Correct Password");
         }
        })    
     }

     const StopSTOAPI =()=>{
        setSuccessLoading(true);
        CommonAPI.StopSTO({StandingOrderId: StandingOrderId},(results) =>{ 
            if(results.message=="Success"){
                setSuccessLoading(false);
                setSuccessMSG(true);
                setErrorMSG();
            }else{
                setSuccessLoading(false);
                setErrorMSG("Serverside Error Found");
            }
           }) 
     }

    const GetSTODetailsAPI = () =>{
        CommonAPI.GetSTODetails({StandingOrderId: StandingOrderId},(result) =>{   
            if(result){                    
              setMainCustomerName(result.savingsAccount?(result.savingsAccount.mainCustomer.title+result.savingsAccount.mainCustomer.firstName+" "+result.savingsAccount.mainCustomer.lastName):null);
              setBenename(result.beneName);
              setBeneBankAccountNum(result.bankAccNo);
              setBankAccountNum(result.savingsAccount?result.savingsAccount.accountNo:null);
              setFrequency( result.frequency);
              setAmount( result.amount);
              setBeneBank(result.bankBr.bank.name);
              setBeneBranch(result.bankBr.name);
              setStartDate(result.startDate);
              setEndDate(result.endDate);
              setYourReference(result.reference);
              setBeneReference(result.beneReference);
              setStatus(result.status==="ACT"?"Active":result.status==="INA"?"Cancelled":result.status==="INI"?"Inactive":"");
              setReferenceNumber(result.stnoRef);
              setSummary(result.accTransSummery);
              setSuccessLoading(false);
            } 
            if(result.message){
                console.log("Invalid Request!");
                setSuccessLoading(false);
            }          
        });
      }

      const StoMaintainToggleModal = () => {
        setEditSTO(!EditSTO) ; 
        GetSTODetailsAPI();
       }

      if(SuccessLoading){
        return ( <div>{ResponseLoadingModal()}</div> );
      }else if(EditSTO){        
        return( <EditSTOPage isOpen={EditSTO} toggle={StoMaintainToggleModal} 
           />)
      }else if(SuccessMSG){
        return(
        <SuccessMsg ConfirmSuccess={SuccessMSG} 
        Close={props.toggle} head="SUCCESSFULLY" head2="CANCELLED" 
        contentline1="Your Standing Order Cancelled Successfully"
         />
         )
    }

        return (

            <Modal
              show={props.isOpen}
              size="xl"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title className='hselect' id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>STANDING ORDER</p><br/>DETAILS
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <Row className='div-background d-flex align-items-start'>                    
                    <Col lg={2}>
                        <div>                           
                            <p className='p-line2'>Name</p>
                            <p className='p-line'>{MainCustomerName}</p>                             
                        </div>
                   </Col>
                    <Col lg={2}>
                        <div>
                            <p className='p-line2'>Account Number</p>
                            <p className='p-line'>{BankAccountNum}</p>
                            <p className='p-line2 m-top'>Ref. Nnumber</p>
                            <p className='p-line'>{ReferenceNumber}</p>
                        </div>
                   </Col>
                    <Col lg={2}>
                        <div>
                            <p className='p-line2'>Beneficiary Details</p>
                            <p className='p-line m-top'>{Benename}</p>
                            <p className='p-line '>{BeneBankAccountNum}</p>
                            <p className='p-line1'>{BeneBank} - {BeneBranch}</p>
                        </div>
                   </Col>
                    <Col lg={2}>
                        
                        <div>
                            <p className='p-line2'>Bene. Reference</p>
                            <p className='p-line '>{BeneReference?BeneReference:"-"} </p>
                            <p className='p-line2 m-top'>Your Reference</p>
                            <p className='p-line'>{YourReference}</p>
                        </div>
                        
                   </Col>
                   <Col lg={2} className="res-align">
                        
                        <div>
                            <p className='p-line2 t-right'>TRANSFER START</p>
                            <p className='p-line t-right'>{StartDate?moment(StartDate).format('DD/MM/YYYY'):"-"} </p>
                            <p className='p-line2 m-top t-right'>TRANSFER END</p>
                            <p className='p-line t-right'>{EndDate?moment(EndDate).format('DD/MM/YYYY'):"U.F.N"}</p>
                            <p className='p-line m-top t-right'></p>
                        </div>                        
                   </Col>
                    <Col lg={2} className="res-align">
                       <div className='d-flex flex-column align-items-end'>  
                            <p className='p-box2 t-center'>{Frequency}</p>                           
                            <p className='p-line2 t-right'>LKR {parseFloat(Amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p> 
                            <div className='d-flex flex-row align-items-end justify-content-end'> 
                            </div>   
                        </div>
                   </Col>             
                </Row>
                <Row className='div-background' style={{marginTop:0, paddingTop:0}}>
                  <Col lg={12} className="d-flex model-btnset flex-row">
                    <Button onClick={()=>setEditSTO(true)} style={{marginRight:10}}>Amend</Button> 
                    <Button onClick={()=>setCancelPayment(true)} className='btn-right'>Cancel</Button> 
                  </Col>
                </Row>     
                {CancelPayment?
                <Row className='div-background'>
                    <Form >
                      <Form.Group as={Row} className="mb-1">
                          <Col lg={4} xs={12}>
                            <Form.Label className="c-font t-right">
                                Password to Confirm Stop of Further Payments
                            </Form.Label>
                          </Col>
                          <Col lg={3} xs={12}>
                          <Form.Control 
                              value = {EnteredPassword}                       
                              onChange={(text)=>setEnteredPassword(text.target.value)} 
                              className=" form-h2" size="sm" maxLength={8} type="password" 
                              placeholder="PASSWORD" />
                          </Col>
                          <Col lg={5} xs={12} className="d-flex std-confirm">
                            <Button  
                            onClick={()=>CheckFirstPassword()}                           
                                className='' 
                                variant="primary" type="submit">
                                CONFIRM
                            </Button>
                          </Col>
                      </Form.Group>
                    <p className='vali-txt'>{ErrorMSG}</p> 
                    </Form>
                </Row>
                :null
                }
                {Summary.length?
                <Table   className='block-top' hover responsive>
                  <thead >
                    <tr>
                    <th className='td-width7 '>Date</th>
                    <th className='td-width7 '>Account<br/> Number</th>
                    <th className='td-width7 '>Transaction <br/>Details</th>
                    <th className='td-width7'>Amount Rs.</th>                           
                    </tr>
                  </thead>
                  <tbody>
                  {Summary.length?Summary.map(( listValue, index ) => {
                       return( 
                            <tr key={index}>
                               <td className='td-width7 ' >
                                   <p className='tb-text  m-top'>{moment(listValue.date).format('DD/MM/YYYY')}</p>
                               </td>
                               <td className='td-width7 '>
                                   <p className='tb-text m-top'>{listValue.accountNo}</p>
                               </td>
                               <td className='td-width7 '>
                                   <p className='tb-text m-top '>{listValue.transactionCode}</p>
                               </td>
                               <td className='td-width7'>
                                   <p className='tb-text m-top '>{parseFloat(listValue.amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                               </td>
                            </tr>
                       )
                        }):
                        <Row className='tablebody'>
                            <p className='h-text block-top'>No Records</p>
                        </Row>
                } 
                  </tbody>
                </Table>
                :null
                }
                
                  
              </Modal.Body>
              
            </Modal>
          );
    }

export default ActiveStoDetails;